jQuery(function($) {
    var body = $('body');

    $('.icon-menu').click(function() {
        var menu = $('.menu');

        if(menu.hasClass('visible')) {
            body.removeClass('menu-open');
            menu.animate({
                opacity: 0,
            }, 500, function() {
                menu.removeClass('visible');
            });
        } else {
            body.addClass('menu-open');
            menu.animate({
                opacity: 1,
            }, 500, function() {
                menu.addClass('visible');
            });
        }
    });
});